import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoriesOverview() {
  const displayCategories = categories.filter((c) => c.id !== "all").slice(0, 6);

  return (
    <section id="categories-overview" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between mb-12 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              内容分类导览
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              探索禁漫天堂丰富的内容分类，找到你喜欢的漫画类型
            </p>
          </div>
          <Link
            to="/categories"
            className="inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/categories?tab=${cat.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-accent-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300 shrink-0">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    {cat.description}
                  </p>
                  <span className="inline-flex items-center gap-1 text-accent-600 text-xs font-medium mt-3">
                    浏览分类
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}